import React from 'react';
import {useNavigate, useLocation} from 'react-router-dom';

export interface TabItem {
  label: string;
  path: string;
}

interface TabsWithRoutingProps {
  tabs: TabItem[];
  basePath?: string;
}

const TabsWithRouting: React.FC<TabsWithRoutingProps> = ({
  tabs,
  basePath = '',
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleTabClick = (path: string) => {
    navigate(`${basePath}${path}`);
  };

  return (
    <div className="flex gap-x-8 px-2 overflow-x-auto border-0 border-b border-solid border-gray-200 no-scrollbar">
      {tabs.map(tab => {
        const isActive = location.pathname === `${basePath}${tab.path}`;

        return (
          <button
            key={tab.path}
            onClick={() => handleTabClick(tab.path)}
            className={`py-3 text-sm font-medium whitespace-nowrap transition-all duration-200 bg-transparent border-0 border-b 
                ${isActive ? ' text-[#9B00CF] border-[#9B00CF]' : 'border-transparent'}`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default TabsWithRouting;
